import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileAlt,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import Logo from "../../assets/hafnia-logo.png";
import { authProvider } from "../../authProvider";
import "./Header.css";

const Header = () => {
  const location = useLocation();

  const logout = () => {
    authProvider.logout();
  };

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <header className="brand-header">
      <div className="brand-header__left">
        <img src={Logo} alt="Hafnia" className="brand-header__logo" />
        <span className="brand-header__title">
          Employee Finance Approval Portal
          {process.env.REACT_APP_STAGE && ` — ${process.env.REACT_APP_STAGE}`}
        </span>
      </div>

      <nav className="brand-header__nav">
        <Link
          to="/requests"
          className={`brand-header__link${isActive("/requests") ? " brand-header__link--active" : ""}`}
        >
          <FontAwesomeIcon icon={faFileAlt} /> Requests
        </Link>

        <span className="brand-header__divider" />

        <button className="brand-header__logout" onClick={logout}>
          <FontAwesomeIcon icon={faRightFromBracket} />
          Logout
          {authProvider.account?.userName && (
            <span className="brand-header__user">({authProvider.account.userName})</span>
          )}
        </button>
      </nav>
    </header>
  );
};

export default Header;
